import { FunctionComponent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ResetPasswordDialog from '../Dialog/resetPassword'
import { useQuery } from '@apollo/client'
import Loading from '@/components/Loading/Loading'
import ErrorMessage from '@/components/_custom/ErrorMessage/ErrorMessage'
import { GET_ACCOUNT } from '@/modules/API/account/accountHandler'
import ChangeLanguageDialog from '../Dialog/changeLanguage'
import SupportDialog from '../Dialog/supportDialog'
import { useAuth } from '@/modules/context/AuthContext'
import { daycareTypeToString } from '@/modules/helper/daycareHelper'
import Desktop from '@/modules/desktopMobile/desktop'
import Mobile from '@/modules/desktopMobile/mobile'
import StaffHomeDesktop from './staffHomeDesktop'
import StaffHomeMobile from './staffHomeMobile'
import { useScreenSize } from '@/modules/desktopMobile/screenSizeContext'

interface StaffHomeProps {
    backendVersion: string
    frontendVersion: string
}

const StaffHome: FunctionComponent<StaffHomeProps> = ({ backendVersion, frontendVersion }: StaffHomeProps) => {
    const { t } = useTranslation()

    const { user } = useAuth()

    const [daycareTypeName, setDaycareTypeName] = useState<string>(t('structure'))

    const [email, setEmail] = useState<string>('')

    const [isDialogForgottenPasswordOpen, setDialogForgottenPasswordOpen] = useState<boolean>(false)
    const [isDialogChangeLanguageOpen, setDialogChangeLanguageOpen] = useState<boolean>(false)

    const [isDialogSupportOpen, setDialogSupportOpen] = useState<boolean>(false)

    const { loading: loadingStaff, error: errorStaff, data: dataStaff } = useQuery(GET_ACCOUNT)

    useEffect(() => {
        if (dataStaff) {
            setEmail(dataStaff.getAccount.email)
        }
    }, [dataStaff])

    const isMobile: boolean = useScreenSize()

    useEffect(() => {
        if (user?.currentDaycare) {
            setDaycareTypeName(
                user.daycares.length > 1 ? t('structures') : daycareTypeToString(user.currentDaycare.type, t, isMobile)
            )
        }
    }, [user?.currentDaycare])

    return (
        <>
            {loadingStaff && <Loading overall />}
            <Desktop>
                <StaffHomeDesktop
                    daycareTypeName={daycareTypeName}
                    backendVersion={backendVersion}
                    frontendVersion={frontendVersion}
                    setDialogChangeLanguageOpen={setDialogChangeLanguageOpen}
                    setDialogForgottenPasswordOpen={setDialogForgottenPasswordOpen}
                    setDialogSupportOpen={setDialogSupportOpen}
                />
            </Desktop>
            <Mobile>
                <StaffHomeMobile
                    daycareTypeName={daycareTypeName}
                    backendVersion={backendVersion}
                    frontendVersion={frontendVersion}
                    setDialogChangeLanguageOpen={setDialogChangeLanguageOpen}
                    setDialogForgottenPasswordOpen={setDialogForgottenPasswordOpen}
                    setDialogSupportOpen={setDialogSupportOpen}
                />
            </Mobile>
            {errorStaff && <ErrorMessage error={t('generalError')} />}
            <ResetPasswordDialog
                email={email}
                open={isDialogForgottenPasswordOpen}
                handleClose={(): void => setDialogForgottenPasswordOpen(false)}
            />
            <ChangeLanguageDialog
                open={isDialogChangeLanguageOpen}
                handleClose={(): void => setDialogChangeLanguageOpen(false)}
            />
            <SupportDialog
                open={isDialogSupportOpen}
                handleClose={(): void => setDialogSupportOpen(false)}
                email={email}
            />
        </>
    )
}

export default StaffHome
